import wretch from 'wretch';

export const FETCH_SESSION_BEGIN = 'FETCH_SESSION_BEGIN';
export const FETCH_SESSION_SUCCESS = 'FETCH_SESSION_SUCCESS';
export const FETCH_SESSION_FAILURE = 'FETCH_SESSION_FAILURE';

export const LOGOUT_BEGIN = 'LOGOUT_BEGIN';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

const fetchSessionSuccess = session => {
  return {
    type: FETCH_SESSION_SUCCESS,
    session
  }
}

const fetchSessionFailure = error => {
  return {
    type: FETCH_SESSION_FAILURE,
    error
  }
}

const logoutSuccess = () => {
  return {
    type: LOGOUT_SUCCESS
  }
}

const logoutFailure = () => {
  return {
    type: LOGOUT_FAILURE
  }
}

export const fetchSession = () => {
  return dispatch => {
    dispatch({ type: FETCH_SESSION_BEGIN });
    wretch('/auth/isloggedin/aprofiel')
      .options({credentials: 'same-origin'})
      .get()
      .json(session => dispatch(fetchSessionSuccess(session)))
      .catch(err => dispatch(fetchSessionFailure(err)));
  }
}

export const logout = () => {
  return dispatch => {
    dispatch({ type: LOGOUT_BEGIN });
    const fromUrl = encodeURIComponent(window.location.href);
    wretch(`/auth/logout/aprofiel?fromUrl=${fromUrl}`)
      .options({credentials: 'same-origin'})
      .get()
      .json(() => dispatch(logoutSuccess()))
      .catch(() => dispatch(logoutFailure()))
  };
}
